module.exports = __webpack_public_path__ + "static/media/answer.aee8fc32.svg";